import { IRequestBuilder } from "../../../core/src/server/requests/RequestBuilder";
import Configs from "../../vendorConfigs/Configs";
import GameModel from "../../../core/src/model/GameModel";
import ConsoleUtil from "../../../core/src/utils/ConsoleUtil";


export default class ResetRealityCheck implements IRequestBuilder {
    get method() {
        return "POST";
    }
  
    get path() {
        return Configs.game.clientConfig.gameServerApi + "/resetrealitycheck";
    }
  
    get requestData() {
        let data = {
            sid: GameModel.sessionID,
            loss: false, // TODO: should be correctly set
            sessionLength: true // TODO: should be correctly set
        };
    
        ConsoleUtil.log("[Requests] Set Reality Check Limits", data);
        return data;
    }
}